import React from "react";
import GameRowCard from "./GameRowCard";
import TableHeader from "./table/TableHeader";

const RefereeRequests = ({ apidata }) => {
  const requestsArray = apidata ? Object.values(apidata).slice(0, 3) : [];

  const isDataEmpty = requestsArray.length === 0 || Object.keys(apidata).length === 0;

  return (
    <div className="self-stretch flex-1 flex flex-col rounded-2xl overflow-hidden bg-white/5 border border-white/10 backdrop-blur-sm">
        <TableHeader
            title={"Referee Requests"}
        />
      <div className="self-stretch flex flex-col items-start justify-start p-4 gap-3 text-center text-[0.69rem]">
        {isDataEmpty ? (
          <div className="text-[.8rem]">No referees currently requesting games</div>
        ) : (
          requestsArray.map((data, index) => <GameRowCard key={index} apidata={data} />)
        )}
      </div>
    </div>
  );
};

export default RefereeRequests;
